import React from "react";

export const ChristianMission = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            viewBox="0 0 520 520"
            width={size}
            {...props}
        >
            <path
                d="M455.079 516H64.921l7.5-118.3a58.453 58.453 0 0145.15-47.211c51.411-11.216 29.591-6.965 99.649-19.134V313.1c57.348.045 65.754 0 85.552 0v18.25c69.336 12.044 48.441 7.945 100.081 19.23a57.69 57.69 0 0144.622 46.9z"
                fill="#747575"
            />
            <path
                d="M295.1 290.541V313.1c-31.384.008-3.961.059-70.206 0v-22.487c21.338 11.517 49.027 11.387 70.206-.072zM181.8 225.554c-52.091-5.651-49.979-42.165-42.771-65.9 1.769-5.332 3.775-10.164 5.307-13.7a88.815 88.815 0 0033.082 22.072z"
                fill="#f6ccaf"
            />
            <path
                d="M375.061 144.869l-32.369 21.517c-12.753 6.5-30.838-28.725-32.264-29.65-48.078 26.8-110.915-12.408-110.915-12.408l-22.1 43.695a88.815 88.815 0 01-33.082-22.072C119.425 67.056 188.21-6.808 270.984 5.016c29.781 3.3 59.536 17.954 71.945 58.349a32.652 32.652 0 017.551 0c13.597 1.768 39.577 13.596 24.581 81.504z"
                fill="#a87e6b"
            />
            <path
                d="M342.7 166.386c0 2.014-3.549 46.66-4.388 59.176-2.976 40.818-38.061 73.736-78.454 73.707-40.233-.291-74.911-31.879-78.071-73.707l-4.363-57.546 22.083-43.686s62.845 39.2 110.919 12.4c1.437.931 19.516 36.154 32.274 29.656z"
                fill="#ffdec7"
            />
            <path
                d="M378.123 206.438c-6.494 9.558-18.666 16.871-39.814 19.116.845-12.515 4.383-57.161 4.383-59.168l32.369-21.517a96.371 96.371 0 014.963 12.3v.1c4.832 14.424 8.397 34.384-1.901 49.169z"
                fill="#f6ccaf"
            />
            <path
                d="M260 414.36c-3.974 0-7.193-2.506-7.193-5.6v-28.466c0-3.092 3.219-5.6 7.193-5.6s7.193 2.506 7.193 5.6v28.467c0 3.093-3.219 5.599-7.193 5.599z"
                fill="#dad7e5"
            />
            <path
                d="M284.528 423.812h-12.539v-12.541a11.989 11.989 0 10-23.978 0v12.541h-12.539a11.989 11.989 0 000 23.977h12.539v37.064a11.989 11.989 0 1023.978 0v-37.064h12.539c15.903-.63 15.897-23.35 0-23.977z"
                fill="#fc6"
            />
            <path
                d="M369.433 343.291c-60.431 57.667-158.651 57.49-218.866 0l30.907-5.73c44.631 33.275 112.508 33.217 157.052 0z"
                fill="#edebf2"
            />
        </svg>
    );
}

export default ChristianMission;